import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import axios from "axios";
import storage from "redux-persist/lib/storage";
import jwtDecode from "jwt-decode";
import Swal from 'sweetalert2'
import Cookies from "universal-cookie";
import { SERVERURL } from "../ServerUrl";


const cookies = new Cookies();

const initialStateFunction = () => ({

  getPricingData:[],
  currentCustomer:null,
  myAllBookingsData:[],
  setTotalValueData:null,
  setObjBookingDetData:[],



});
//get pricing
export const getPricing = createAsyncThunk("getPricing", async () => {
 
  try {
    const data1 = await axios.get(
      `${SERVERURL}/getPricing`
    );

   
    return data1.data.pricing;
  } catch (err) {
    console.log("NoLoginError", err?.response?.data?.message);
  }
});


//Book Vehicle
export const bookeVehicle = createAsyncThunk("bookeVehicle", async (data) => {

  try {
    const data1 = await axios.post(
      `${SERVERURL}/bookVehicle`,
      data
    );

    console.log("DataResDataRes", data1.data);
   
    return data1;
  } catch (err) {
    console.log("NoLoginError", err?.response?.data?.message);
  }
});


//Register customer
export const registerCustomer = createAsyncThunk("registerCustomer", async (data) => {

  console.log("userData",data)
  try {
    const data1 = await axios.post(
      `${SERVERURL}/registerCustomer`,
      
      data
    );

    console.log("DataResDataRes", data1.data);
   
    return data1;
  } catch (err) {
    console.log("NoLoginError", err?.response?.data?.message);
  }
});

//login customer
export const loginCustomer = createAsyncThunk("loginCustomer", async (data) => {

  try {
    const data1 = await axios.post(
      `${SERVERURL}/loginCustomer`,
      
      data
    );

    console.log("DataResDataRes", data1.data);

    console.log("DataResDataRes", data1.data);
    cookies.set('_id', data1?.data?.user?._id, { path: '/' });

    cookies.set("userType",data1?.data?.user?.userType,{ path: '/' });
    cookies.set("token",data1?.data?.token,{ path: '/' });


   
    return data1.data;
  } catch (err) {

    console.log("NoLoginError", err?.response);
    return err?.response
  }
});
//edit customer
export const editCustomer = createAsyncThunk("editCustomer", async ({user,idData}) => {


console.log("ideditCustomer",idData)
  try {
    const data1 = await axios.put(
      `${SERVERURL}/editProfile/${idData.id}`,
      
      user
    );

      
    console.log("dataPRofle",data1)


   
    return data1.data;
  } catch (err) {
    console.log("NoLoginError", err?.response?.data?.message);
  }
});

//get myBooking
export const myAllBookings = createAsyncThunk("myAllBookings", async ({id}) => {

  console.log("userId",id)
 
  try {
    const data1 = await axios.get(
      `${SERVERURL}/myBookings/${id}`
      
    );

   
    return data1;
  } catch (err) {
    console.log("NoLoginError", err?.response?.data?.message);
  }
});



export const CustomerReducer = createSlice({
  name: "CustomerReducer",
  initialState: initialStateFunction(),
  reducers: {
    setCurrentUser(state, action) {
      state.currentUser = action.payload;
    },
    setTotalValue(state, action) {
      state.setTotalValueData = action.payload;
    },
    setObjBookingDet(state, action) {
      state.setObjBookingDetData = action.payload;
    },
    resetUser(state, action) {
      state.currentCustomer =null;
    },

    resetState: (state) => initialStateFunction(),
  },
  extraReducers: {
    [getPricing.fulfilled]: (state, action) => {
      state.getPricingData = action.payload;
    },
   
    [loginCustomer.fulfilled]: (state, action) => {
      state.currentCustomer = action.payload;
    },
   
    [myAllBookings.fulfilled]: (state, action) => {
      state.myAllBookingsData = action.payload;
    },
   
  },
});




const persistConfig = {
  key: "root",
  storage,
  whitelist: ["CustomerReducer"],
};

const user = CustomerReducer.reducer;

// Action creators are generated for each case reducer function
export const { setCurrentUser,setTotalValue,setObjBookingDet,resetUser } = CustomerReducer.actions;
export default persistReducer(persistConfig, user);
